import { Button, Container } from "react-bootstrap";
import Navigation from "../Navbar";
import { useContext, useEffect, useState } from "react";
import Spinner from "../Spinner";
import { useNavigate } from "react-router-dom";
import api from "../Api/Api";
import Marcaveiculos from '../../Components/JsonData/MarcaVeiculo.json'
import { UserContext } from '../../context/UserContext';

const Veiculo = () => {
    const navigate = useNavigate(); 
    const {user} = useContext(UserContext)
    const [placa, setPlaca] = useState('')
    const [marcas, setMarcas] = useState(['']);
    const [marca, setMarca] = useState('')
    const [modelo, setModelo] = useState('')
    const [cor, setCor] = useState('')
    const [motor, setMotor] = useState('')
    const [ano, setAno] = useState('')
    const [kmatual, setKmatual] = useState('')
    const [cadok, setCadok] = useState(false)
    const [ShowLoading, setShowLoading] = useState(false)
    const credentials = btoa(`${user.userRest}:${user.passRest}`); 
    const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "User-Agente": "PneusBrasil",
        "Accept": "*/*",
        'Authorization': `Basic ${credentials}`,
      }     
    const getplaca = (placa01: string) => {
        if(placa !== ''){
            api.get('Dadosveiculo?filial='+user.filial+'&consulta='+placa01,{headers})
            .then(response => {
                if (response.data.Dadosveiculo.length > 0 ){            
                    setMarca(response.data.Dadosveiculo[0]['marca'])
                    let p1 = [response.data.Dadosveiculo[0]['marca']]
                    for (let i = 0; i <= marcas.length; i++) {
                        p1.push(marcas[i])
                      }                    
                    // marcas.push(response.data.Dadosveiculo[0]['marca'])
                    setMarcas(p1)                      
                    setModelo(response.data.Dadosveiculo[0]['modelo']) 
                    setCor(response.data.Dadosveiculo[0]['cor'])  
                    setMotor(response.data.Dadosveiculo[0]['motor'])   
                    setAno(response.data.Dadosveiculo[0]['ano']) 
                    setKmatual(response.data.Dadosveiculo[0]['kmatual'])        
                }else{
                    setMarca('')
                    setModelo('') 
                    setCor('')  
                    setMotor('')   
                    setAno('') 
                    setKmatual('')                     
                }                                   
            });
        }        
    }    

    const handleCadastro = (e: any) => {
        if(e.target.id === 'placa'){
            setPlaca(e.target.value.toUpperCase( ))
        }else if (e.target.id === 'marca'){
            setMarca(e.target.value.toUpperCase( ))
        }else if (e.target.id === 'modelo'){
            setModelo(e.target.value.toUpperCase( ))
        }else if (e.target.id === 'cor'){
            setCor(e.target.value.toUpperCase( ))
        }else if (e.target.id === 'motor'){
            setMotor(e.target.value)
        }else if (e.target.id === 'ano'){
            setAno(e.target.value)
        }else if (e.target.id === 'kmatual'){
            setKmatual(e.target.value)
        }
    };    
    const handlingenviar = (e: any) =>{
        setShowLoading(true)
        if((placa && marca && modelo && cor ) === ''){
            alert('Preencher os campos obrigatorios!')
            setShowLoading(false)
            return
        }        
        const url = 'Veiculo';
        // const headers = {
        //     'Content-Type': 'application/json;charset=UTF-8',
        //     "Access-Control-Allow-Origin": "*",
        //     "User-Agente": "PneusBrasil",
        //     "Accept": "*/*",
        //   }         
        const data = {
            'Empresa':"01",
            'Filial':"01",
            'ZA_PLACA': placa,
            'ZA_MARCA': marca,
            'ZA_MODELO': modelo,
            'ZA_COR': cor,
            'ZA_MOTOR': motor,
            'ZA_ANO': ano,
            'ZA_KMATUAL': kmatual            
        }
        api.post(url,data, {headers})
        .then(function (response) {
            if(response.data['info'] === 'erro'){
                setShowLoading(false)
                alert('Erro na alteração! Placa: '+ response.data['codigo'])
            }  
            if(response.data['info'] === 'criado'){ 
                setShowLoading(false)
                alert('Veiculo cadastrado com sucesso, placa: '+ response.data['codigo'] )
                setCadok(true)               
            } 
            if(response.data['info'] === 'alterdo'){
                setShowLoading(false)
                alert('Veiculo alterado com sucesso, Placa: '+ response.data['codigo'])
            }                                  
        })
        .catch(function (error) {
            console.error(error);
            setShowLoading(false)
            alert('Alert: Erro de conexão com servidor! ')
        });                        
    }
    const chageselectmarca = (e: any) => {
        if (e.target.value !== '') {
            setMarca(e.target.value.substring(0,6))
        }          
    }     
    useEffect(() => {
        if(marcas.length === 1){
            let p_1 = []
          for (let i = 0; i <= Marcaveiculos.data.length; i++) {
            p_1.push(Marcaveiculos.data[i])
          }
          setMarcas(p_1)
      }         
        if(cadok) { 
            navigate('/novaentrada')
        }
                       
    })    
    return(
        <>
            <Navigation />
            <Container>
                <div>
                    <span className="d-flex justify-content-center fs-3 text-primary">Cadastro de veículos</span>
                </div> 
                <div className="row"> 
                    <div className="input-group mt-2 mb-2 col" >
                        <span className="input-group-text me-2" id="basic-addon1">Placa</span><span className="me-2 text-danger">*</span>
                        <input type="text" id="placa" className="w-50 " value={placa} onChange={ (e) => { handleCadastro(e) }} onBlur={(e) => {getplaca(e.target.value)}} placeholder="PBI1A25"/>
                    </div>                                         
                    <div className="input-group mt-2 mb-2 col-sm">
                        <span className="input-group-text me-2" id="basic-addon1">Marca</span><span className="me-2 text-danger">*</span>
                        {/* <input type="text" id="marca" className="w-50 " value={marca} onChange={ (e) => { handleCadastro(e) }} placeholder="000002"/> */}
                        <select onChange={(e) => chageselectmarca(e)}>
                            {marcas.map((i: any, k: any) => 
                                <option key={k} value={marcas[k]}>{marcas[k]}</option> 
                            )}
                        </select>                         
                    </div>   
                    <div className="input-group mt-2 mb-2 col-sm">
                        <span className="input-group-text me-2" id="basic-addon1">Modelo</span><span className="me-2 text-danger">*</span>
                        <input type="text" id="modelo" className="w-50" value={modelo} onChange={ (e) => { handleCadastro(e) }}  placeholder="GOL"/>
                    </div>                         
                </div>    
                <div className="row"> 
                    <div className="input-group mt-2 mb-2 col" >
                        <span className="input-group-text me-2" id="basic-addon1">Cor....</span><span className="me-2 text-danger">*</span>
                        <input type="text" id="cor" className="w-50 " value={cor}  onChange={ (e) => { handleCadastro(e) }} placeholder="BRANCA"/>
                    </div>                                         
                    <div className="input-group mt-2 mb-2 col-sm">
                        <span className="input-group-text me-2" id="basic-addon1">Motor</span><span className="me-2 text-success">*</span>
                        <input type="text" id="motor" className="w-50 " value={motor} onChange={ (e) => { handleCadastro(e) }} placeholder="1.0"/>
                    </div>   
                    <div className="input-group mt-2 mb-2 col-sm">
                        <span className="input-group-text me-2" id="basic-addon1">Ano ......:</span><span className="me-2 text-success">*</span>
                        <input type="text" id="ano" className="w-50" value={ano} onChange={ (e) => { handleCadastro(e) }}  placeholder="2024"/>
                    </div>                         
                </div>  
                <div className="input-group mt-2 mb-2">
                    <span className="input-group-text me-2" id="basic-addon1">KM Atual</span>
                    <input type="text" id="kmatual" className="w-25" value={kmatual} onChange={ (e) => { handleCadastro(e) }}  placeholder="1000"/>
                </div>  
                <div className="col-12">
                    <Button type="submit" className="btn btn-success" onClick={(e) => handlingenviar(e)}>Salvar</Button>
                </div>
            <Spinner isLoading={ShowLoading} />                                                                                        
            </Container>
        </>
    )
};

export default Veiculo;